// extracted by mini-css-extract-plugin
export default {"randomButton":"SetUp_randomButton__a5b9x","defaultButton":"SetUp_defaultButton__fwSmh"};